const state = () => ({
    reportData: [],
    overviewData: null
});

const getters = {
    getReportData: (state) => state.reportData || [],
    getOverviewData: (state) => state.overviewData
};

const mutations = {
    setReportData(state, { data }) {
        state.reportData = data;
    },
    setOverviewData(state, overview) {
        state.overviewData = overview;
    }
};

const actions = {
    saveReportData({ commit }, { data }) {
        commit('setReportData', { data });
    },
    saveOverviewData({ commit }, overview) {
        commit('setOverviewData', overview);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
